import React, { useState } from 'react';
import { Input, Button } from 'antd';
import { SearchOutlined, FileExcelOutlined } from '@ant-design/icons';
import { exportLedgerToCSV } from '../../../utils/exportUtils';
import styles from './styles/table-actions.module.scss';

const ReportsTransactionsTableActions = ({ ledger, setRows, rows }) => {
    const [searchText, setSearchText] = useState('');

    const handleSearch = (value) => {
        setSearchText(value);
        filterData(value);
    };

    const handleDownloadExcel = () => {
        exportLedgerToCSV(rows || ledger);
    };

    const filterData = (search) => {
        let filteredData = [...(ledger || [])];

        if (search) {
            filteredData = filteredData.filter((item) => {
                const searchLower = search.toLowerCase();
                return (
                    item.account_name?.toLowerCase().includes(searchLower) ||
                    item.user_name?.toLowerCase().includes(searchLower) ||
                    item.client_id?.toLowerCase().includes(searchLower)
                );
            });
        }

        setRows(filteredData, 'transactions');
    };

    return (
        <div className={styles.container}>
            {/* Search and Action Bar */}
            <div className={styles.searchAndActionsBar}>
                <div className={styles.searchContainer}>
                    <Input
                        placeholder="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                        className={styles.searchInput}
                    />
                    <Button 
                        type="primary" 
                        icon={<SearchOutlined />} 
                        className={styles.searchButton}
                    />
                </div>
                <div className={styles.actionButtons}>
                    <Button 
                        type="default"
                        icon={<FileExcelOutlined />} 
                        onClick={handleDownloadExcel}
                        className={styles.actionButton}
                    >
                        Export as XLSX
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ReportsTransactionsTableActions;

